import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'
import { useSelector } from 'react-redux'

import { stepSelector } from './selectors'

const ModalContent = withSafeSuspense(lazy(
  async () => ({ default: (await import('./modal_content')).ModalContent })
), null)

export const SubscriptionModal = () => {
  const step = useSelector(stepSelector)

  if (!step) return null

  return <ModalContent step={step} />
}
